import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CarIcon, TruckIcon, KeyIcon, FuelIcon, DiscIcon, WrenchIcon, BatteryIcon, ZapIcon, ActivityIcon } from 'lucide-react';
const tabs = ['Emergency Roadside', 'Fuel & Tires', 'Battery & Tech'];
const servicesData = {
  'Emergency Roadside': [{
    icon: CarIcon,
    title: 'Accident Recovery',
    desc: 'Safe and secure transport after a collision.'
  }, {
    icon: TruckIcon,
    title: 'Flatbed Towing',
    desc: 'Damage-free towing for all vehicle types.'
  }, {
    icon: KeyIcon,
    title: 'Lockout Service',
    desc: 'Fast access when you leave keys inside.'
  }],
  'Fuel & Tires': [{
    icon: FuelIcon,
    title: 'Fuel Delivery',
    desc: 'Gas or diesel delivered right to your location.'
  }, {
    icon: DiscIcon,
    title: 'Tire Change',
    desc: 'Swap your flat with your spare quickly.'
  }, {
    icon: WrenchIcon,
    title: 'Tire Repair',
    desc: 'On-site patching for minor punctures.'
  }],
  'Battery & Tech': [{
    icon: ZapIcon,
    title: 'Jump Start',
    desc: 'Powerful jump boxes to get you running.'
  }, {
    icon: BatteryIcon,
    title: 'Battery Replace',
    desc: 'New battery installation on the spot.'
  }, {
    icon: ActivityIcon,
    title: 'Diagnostic Scan',
    desc: 'Read engine codes to identify issues.'
  }]
};
export function Services() {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  return <section id="services" className="py-20 bg-white" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="text-center mb-12" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-8" data-id="element-206">
            Service Engine
          </h2>

          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-8 border-b border-gray-200" data-id="element-207">
            {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`relative pb-4 px-2 text-sm md:text-base font-medium transition-colors ${activeTab === tab ? 'text-secondary font-bold' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-208">
                {tab}
                {activeTab === tab && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-[3px] bg-primary" initial={false} transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-209" />}
              </button>)}
          </div>
        </div>

        {/* Tab Content */}
        <div className="min-h-[300px]" data-id="element-210">
          <AnimatePresence mode="wait" data-id="element-211">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
              {servicesData[activeTab as keyof typeof servicesData].map((service, idx) => <div key={idx} className="group perspective-1000 h-64 cursor-pointer" data-id="element-213">
                    <div className="relative w-full h-full transition-transform duration-700 transform-style-3d group-hover:rotate-y-180" data-id="element-214">
                      {/* Front of card */}
                      <div className="absolute inset-0 backface-hidden bg-white border border-gray-200 rounded-[10px] p-8 flex flex-col items-center justify-center text-center shadow-sm" data-id="element-215">
                        <service.icon className="w-12 h-12 text-secondary mb-4 stroke-[1.5]" data-id="element-216" />
                        <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-217">
                          {service.title}
                        </h3>
                        <p className="text-gray-500 text-base" data-id="element-218">
                          {service.desc}
                        </p>
                      </div>

                      {/* Back of card */}
                      <div className="absolute inset-0 backface-hidden bg-secondary rounded-[10px] p-8 flex flex-col items-center justify-center text-center rotate-y-180 shadow-xl" data-id="element-219">
                        <service.icon className="w-12 h-12 text-white mb-4 stroke-[1.5]" data-id="element-220" />
                        <h3 className="text-xl font-bold text-white mb-4" data-id="element-221">
                          {service.title}
                        </h3>
                        <button className="bg-white text-secondary font-bold py-2 px-6 rounded-full text-sm hover:bg-gray-100 transition-colors" data-id="element-222">
                          Request Service
                        </button>
                      </div>
                    </div>
                  </div>)}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}